import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Theme } from 'styles/ThemeTyping';

function CsvUploadLoading() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.loadingContainer}>
        <CircularProgress
          size={141}
          className={classes.loadingIndicator}
          title="Loading Indicator"
        />
        <Typography variant="h5">Checking Your File...</Typography>
        <Typography variant="body2" className={classes.content}>
          We’re doing a few checks to ensure your file can be mapped into Sift properly. This may
          take a while depending on the size of the uploaded file.
        </Typography>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: 'auto',
    textAlign: 'center',
  },
  loadingIndicator: {
    color: theme.palette.success.main,
  },
  loadingContainer: {
    maxWidth: 297,
    minHeight: 273,
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  content: {
    color: theme.colors.gray1,
  },
}));

export default CsvUploadLoading;
